import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-2 mb-3" }
const _hoisted_2 = { class: "flex items-center gap-2 flex-wrap min-w-0" }
const _hoisted_3 = ["innerHTML", "title"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "absolute right-0 top-8 mt-1 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20"
}
const _hoisted_6 = { class: "text-sm text-gray-900 mb-2 pr-8" }
const _hoisted_7 = { class: "text-xs text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bg-white rounded-lg border border-gray-200 p-4 relative cursor-pointer hover:shadow-md transition-shadow",
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click', _ctx.item)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium rounded-full shrink-0", _ctx.frequencyBadgeClass])
        }, [
          _createTextVNode(_toDisplayString(_ctx.formatFrequencyLabel(_ctx.item.frequency)) + " ", 1),
          (_ctx.item.resultsChanged)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                innerHTML: _ctx.CHECK_ICON,
                class: "w-3.5 h-3.5 text-green-600 shrink-0",
                title: _ctx.UPDATE_TOOLTIP
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.item.initialResultCount != null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["inline-flex items-center justify-center min-w-[1.5rem] px-2 py-0.5 text-xs font-medium rounded-full shrink-0", _ctx.frequencyBadgeClass])
            }, _toDisplayString(_ctx.item.initialResultCount), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        ref: "menuContainerRef",
        class: "shrink-0",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("button", {
          class: "text-gray-400 hover:text-gray-600 p-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleMenu', _ctx.item.id)))
        }, [
          _createElementVNode("span", { innerHTML: _ctx.MORE_ICON }, null, 8, _hoisted_4)
        ]),
        (_ctx.openMenuId === _ctx.item.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleViewDetails && _ctx.handleViewDetails(...args)))
              }, " View Details "),
              _createElementVNode("button", {
                class: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)))
              }, " Remove ")
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.item.query), 1),
    _createElementVNode("span", _hoisted_7, " Added on " + _toDisplayString(_ctx.formatWatchlistDate(_ctx.item.addedAt)), 1)
  ]))
}